import { render, staticRenderFns } from "./FreeTextQuestion.vue?vue&type=template&id=5560482c&"
import script from "./FreeTextQuestion.vue?vue&type=script&lang=js&"
export * from "./FreeTextQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FreeTextQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports